function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popup from "semantic-ui-react/dist/es/modules/Popup/Popup.js";
import classnames from 'classnames';
import { some } from "../../../utils/some";
import { GUESTS } from "../../../utils/default-strings";
import { Counter } from "../Counter";
import { Icon, ICON_NAMES } from "../../elements/Icon";
import { FlexContainer } from "../../layout/FlexContainer";
import { testidFactory } from "../../../utils/testid";
var TEST_ID_PREFIX = 'counter-dropdown';
var testid = testidFactory(TEST_ID_PREFIX);
export var Component = function Component(_ref) {
  var counterName = _ref.counterName,
      counterValue = _ref.counterValue,
      popupId = _ref.popupId,
      dropdownLabel = _ref.dropdownLabel,
      maximumCounterValue = _ref.maximumCounterValue,
      onChange = _ref.onChange,
      willOpenAbove = _ref.willOpenAbove;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  return React.createElement(Popup, {
    className: "counter-dropdown",
    content: React.createElement(FlexContainer, {
      flexDirection: "row",
      justifyContent: "space-between"
    }, React.createElement(Counter, {
      max: maximumCounterValue,
      name: counterName,
      onChange: onChange,
      value: counterValue
    })),
    "data-testid": testid(),
    id: popupId,
    on: "click",
    onClose: function onClose() {
      return setIsOpen(false);
    },
    onOpen: function onOpen() {
      return setIsOpen(true);
    },
    open: isOpen,
    position: willOpenAbove ? 'top left' : 'bottom left',
    text: dropdownLabel,
    trigger: React.createElement("div", {
      className: classnames('dropdown-container', {
        dirty: some(counterValue)
      }),
      role: "button"
    }, React.createElement("div", {
      className: classnames('ui selection dropdown', 'counter-dropdown-trigger', {
        active: isOpen
      })
    }, React.createElement("span", null, dropdownLabel), React.createElement(Icon, {
      name: ICON_NAMES.CARET_DOWN
    })))
  });
};
Component.displayName = 'CounterDropdown';
Component.defaultProps = {
  popupId: undefined,
  counterName: undefined,
  counterValue: undefined,
  dropdownLabel: GUESTS,
  maximumCounterValue: undefined,
  onChange: undefined,
  willOpenAbove: false
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  counterName: PropTypes.string,
  counterValue: PropTypes.number,
  dropdownLabel: PropTypes.string,
  maximumCounterValue: PropTypes.number,
  onChange: PropTypes.func,
  popupId: PropTypes.string,
  willOpenAbove: PropTypes.bool
} : {};